var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvirnmentInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #323232;\n      }\n\n      .cls-2 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.23,19.37c-.37.53-.78,1.04-1.23,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,3.1c2.21,2.34,3.38,5.35,3.49,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,20.9c-4.67-4.93-4.67-12.87,0-17.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.18,20.74c-.7.17-1.42.26-2.18.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,3c4.98,0,9,4.02,9,9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,21c-4.98,0-9-4.02-9-9S7.02,3,12,3"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.51,
    y1: 9,
    x2: 20.49,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.51,
    y1: 15,
    x2: 12.62,
    y2: 15
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.85,
    cy: 16.56,
    r: 5.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.93,14.83c-.15,0-.28-.05-.39-.14-.11-.09-.16-.22-.16-.38,0-.15.06-.27.17-.37s.24-.15.39-.15.27.04.37.13c.11.09.16.22.16.38s-.05.29-.16.38-.23.14-.38.14ZM18.46,15.93v3.06c0,.21-.05.37-.16.48-.1.11-.24.16-.4.16s-.29-.06-.39-.17-.15-.27-.15-.48v-3.03c0-.21.05-.37.15-.47s.23-.16.39-.16.29.05.4.16c.1.11.16.25.16.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvirnmentInfo);
export default __webpack_public_path__ + "static/media/EnvirnmentInfo.f9a39819d88e533a8344acd6b8ec2042.svg";
export { ForwardRef as ReactComponent };